<script lang="ts">
  import { AssetPaths } from '../../assets/asset-store';
  import { SCRAP_DISPLAY } from '../../game/constants/hud';

  const { scrap }: { scrap: number } = $props();
</script>

<!-- `ScrapBar.png` with the count inside it, top left. -->
<div
  class="scrap"
  style:left="{SCRAP_DISPLAY.image.x}px"
  style:top="{SCRAP_DISPLAY.image.y}px"
  style:width="{SCRAP_DISPLAY.image.width}px"
  style:height="{SCRAP_DISPLAY.image.height}px"
  style:background-image="url({AssetPaths.ui('ScrapBar')})"
>
  <span
    class="hud-text scrap__value"
    style:left="{SCRAP_DISPLAY.text.x}px"
    style:top="{SCRAP_DISPLAY.text.y}px"
    style:font-size="{SCRAP_DISPLAY.text.font}px"
    data-testid="scrap">Scrap: {scrap}</span
  >
</div>

<style>
  .scrap {
    position: absolute;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .scrap__value {
    color: #000;
  }
</style>
